import { createContext } from 'react'
import { Supplier } from '@/modules/sales/clients/types/Supplier.ts'

export interface UninstallBySupplierContextProps {
  articleData: {
    brandId: string
    brandName: string
    supplier: Supplier | null
  }
  setArticleData: (data: UninstallBySupplierContextProps['articleData']) => void
}

export const UninstallAppBySupplierContext =
  createContext<UninstallBySupplierContextProps | null>(null)
